export interface ErrorPageContentProps {
  statusCode: number
  apiCode?: string
  message?: string
  messageDetail?: string
}

export type SlideOptions = {
  pageFadeDuration: string // スライドが変更されたときのフェードアニメーション時間(0以上)
  pageStartWait: string // スライドが変更されてから始まるまでの時間(0以上)
  pageEndWait: string // スライドが完了した後の待ち時間(0以上)
  pageNoMediaDisplayTime: string // メディアがない場合1枚のスライドを表示する時間ms
  bgmUrl: string // BGMのパス(bgm_file_path)
  bgImageUrl: string // 背景画像のパス(component内で + {layout_id}_{color_status}.mp3)
}

export type MasterLayoutId =
  | '1' // タイトル(表紙)
  | '2' // 目次
  | '3' // テキストと画像
  | '4' // 箇条書きと画像
  | '5' // 2つの画像
  | '6' // 箇条書き
  | '7' // 3つの画像
  | '8' // ビフォー/アフター
  | '9' // 強調テキスト
  | '10' // YouTube
  | '11' // 画像'

export type SlideDesignStatusType =
  | '1' // Basic
  | '2' // Pop
  | '3' // Cool

export type SlideColorStatusType =
  | '1' // グリーン_ベーシック
  | '2' // ブルー_ベーシック
  | '3' // オレンジ_ベーシック
  | '4' // ピンク_ベーシック
  | '5' // グリーン_ポップ
  | '6' // ブルー_ポップ
  | '7' // オレンジ_ポップ
  | '8' // ピンク_ポップ
  | '9' // グリーン_クール
  | '10' // ブルー_クール
  | '11' // オレンジ_クール
  | '12' // エメラルド_クール

export type SlideContentsType =
  | '1' // タイトル
  | '2' // メインテキスト
  | '3' // サブテキスト
  | '4' // 画像
  | '5' // Youtube

export type SlideContent = {
  order_by: number
  name: string
  contents: string | null
  contents_type: SlideContentsType
  contents_size: string | null
}

export type SlidePage = {
  slide_id: string
  order_by: number
  master_layout_id: MasterLayoutId // MasterLayout
  narration_path?: string
  narration_text?: string
  slide_contents: SlideContent[]
}

export type SlideData = {
  slide_clip_id: string
  bgm_file_path?: string
  color_status: SlideColorStatusType
  design_status: SlideDesignStatusType
  publication_status: '0' | '1' // 公開ステータス '0':下書き、'1':公開
  share_status: '0' | '1' // 共有ステータス 施設の場合、必須 '0':非共有、'1':共有
  logo_status: '0' | '1' // ロゴステータス 施設の場合、必須 '0':非表示、'1':表示
  logo_image_url: string
  slides: SlidePage[],
  title?: string
}

export type SlidePageProps = {
  index: number
  isRestartPage: boolean
  isActive: boolean
  isPlay: boolean
  isMute: boolean
  color_status: SlideColorStatusType
  design_status: SlideDesignStatusType
  pageData: SlidePage
  options: SlideOptions
  logoStatus: '0' | '1' // ロゴステータス 施設の場合、必須 '0':非表示、'1':表示
  logoImageUrl?: string
  isPdf?: boolean
}

export type PdfPageProps = {
  index: number
  groupIndex: number
  isActive: boolean
  color_status: SlideColorStatusType
  design_status: SlideDesignStatusType
  pageData: SlidePage[]
  options: SlideOptions
  logoStatus: '0' | '1' // ロゴステータス 施設の場合、必須 '0':非表示、'1':表示
  logoImageUrl?: string
  orientation?: string
}

export type SlideContainerProps = {
  data: SlideData
  options?: SlideOptions
  clip_url_param?: string
}

export type PdfContainerProps = {
  data: SlideData
  options?: SlideOptions
  clip_url_param?: string
  orientation?: string
  scale: number
  isActive: boolean
}

export type PreviewSlidePageProps = {
  slide: SlidePage
  color_status: SlideColorStatusType
  design_status: SlideDesignStatusType
}

export type SlideClip = {
  slide_clips_id: string,
  slide_clips_title: string,
  category_id: string,
  category_name: string,
  slide_clips_updated_at: string,
}

export type Media = {
  media_id: string,
  media_file_name: string,
  category_id: string,
  category_name: string,
  media_file_path: string,
  media_updated_at: string,
}

export type Facility = {
  name: string
}
export type ClipLibraryData = {
  slide_clips: SlideClip[]
  media: Media[]
  facility: Facility
}

export type ClipLibraryListProps = {
  clipLibraryList: ClipLibraryData
  facilityId: string
}

export interface MessageDialogProps {
  message?: string
  primaryButtonText?: string
  secondaryButtonText?: string
  visible?: boolean
  showCloseMessage?: boolean
  showSecondaryMessage?: boolean
  messageSecondary?: string
}

export interface ModalSurveyProps {
  visible?: boolean
  message?: string
  primaryButtonText?: string
  secondaryButtonText?: string
  disabledButtonSubmit?: boolean
}

export const getDefaultSlideData = (): SlideData => ({
  slide_clip_id: '',
  bgm_file_path: '',
  color_status: '1',
  design_status: '1',
  publication_status: '0',
  share_status: '0',
  logo_status: '0',
  logo_image_url: '',
  slides: [{
    slide_id: '',
    order_by: 0,
    master_layout_id: '1',
    slide_contents: [{
      order_by: 0,
      name: '',
      contents: '',
      contents_type: '1',
      contents_size: null,
    }],
  }],
})

export const getDefaultClipLibraryData = (): ClipLibraryData => ({
  slide_clips: [
    {
      slide_clips_id: '',
      slide_clips_title: '',
      category_id: '',
      category_name: '',
      slide_clips_updated_at: '',
    },
  ],
  media: [
    {
      media_id: '',
      media_file_name: '',
      category_id: '',
      category_name: '',
      media_file_path: '',
      media_updated_at: '',
    },
  ],
  facility: { name: '' },
})
